import { render } from "./ChoiceV1.vue?vue&type=template&id=6c325c41&scoped=true"
import script from "./ChoiceV1.vue?vue&type=script&lang=js"
export * from "./ChoiceV1.vue?vue&type=script&lang=js"

import "./ChoiceV1.vue?vue&type=style&index=0&id=6c325c41&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c325c41"]])

export default __exports__